import { gql } from "@apollo/client";

const STUDENT_LOGOUT = gql`
  mutation StudentLogout {
    studentLogout {
      authenticatable {
        active
      }
    }
  }
`;

export default STUDENT_LOGOUT;
